<div class="flex-auto">
    <div class="flex w-full">

        <mat-form-field class="w-1/3 mt-5">
            <input matInput (ngModelChange)="recherche($event)" [formControl]="searchControl" [placeholder]="'Rechercher un abonnement'">
        </mat-form-field>
        
        <div class="w-1/3 inline-flex items-center font-bold">
            Abonnements bientôt expirés
        </div>
        
        <div class="mat-form-field flex flex-col w-1/6">
            <mat-label>&nbsp;</mat-label>
            <button (click)="exporter()" class="shadow rounded-2xl overflow-hidden cursor-pointer mt-2 ml-2 bg-card  bg-green-900" mat-stroked-button>
                <mat-icon style="color: white;" svgIcon="iconsmind:refresh" [ngClass]="{'animate-spin-slow': actualiser['btn2']}" *ngIf="actualiser['btn2']"></mat-icon> &nbsp;
                <label class="ml-0 cursor-pointer" style="color: white;" *ngIf="!actualiser['btn2']">Exporter</label>
            </button>
        </div>
    </div>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z1 w-full">
        <ng-container matColumnDef="nomprenom">
            <th mat-header-cell *matHeaderCellDef> Nom abonné </th>
            <td mat-cell *matCellDef="let element" class="text">
                <a class="whitespace-nowrap text-primary-500" [routerLink]="['/abonnes/show/'+element.abonne_id]" routerLinkActive="router-link-active">{{element.nomprenom}}</a>
            </td>
        </ng-container>
        <ng-container matColumnDef="date_fin">
            <th mat-header-cell *matHeaderCellDef> Date d’expiration </th>
            <td mat-cell *matCellDef="let element"  class="center"> 
                <span class="inline-flex items-center font-bold text-xs px-2.5 py-0.5 rounded-full tracking-wide"  [ngClass]="getExpirationClass(element.date_fin)">{{element?.date_fin | date}}</span>
             </td>
        </ng-container>
        <ng-container matColumnDef="type_abonnement">
            <th mat-header-cell *matHeaderCellDef> Abonnement </th>
            <td mat-cell *matCellDef="let element"> {{element.type_abonnement}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let element;let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSize]="5"></mat-paginator>
    </div>